// Central data-testid registry for B2B flows.
export const testIds = {
  // Navbar
  navbarLogin: "nav-link-login",
  navbarRegister: "nav-link-register",
  navbarMyOrders: "nav-link-my-orders",
  navbarCart: "nav-link-cart",
  navbarLogout: "nav-link-logout",
  navbarAdmin: "nav-link-admin",
  navbarApprovalBadge: "nav-approval-badge",

  // Auth forms
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  loginForgotPassword: "login-forgot-password",

  forgotEmail: "forgot-email",
  forgotSubmit: "forgot-submit",
  forgotError: "forgot-error",
  forgotSuccess: "forgot-success",
  forgotBackToLogin: "forgot-back-to-login",

  resetPassword: "reset-password",
  resetConfirm: "reset-confirm",
  resetSubmit: "reset-submit",
  resetError: "reset-error",
  resetSuccess: "reset-success",
  resetGoToLogin: "reset-go-to-login",

  registerBusinessName: "register-business-name",
  registerCompanyName: "register-company-name",
  registerContactName: "register-contact-name",
  registerEmail: "register-email",
  registerPhone: "register-phone",
  registerPassword: "register-password",
  registerVolume: "register-expected-volume",
  registerSubmit: "register-submit",
  registerError: "register-error",
  registerSuccess: "register-success",

  // Product
  productAddToCart: "product-add-to-cart",
  productQty: "product-qty",
  productMsrp: "product-msrp",
  productWholesale: "product-wholesale",
  productMoq: "product-moq",
  productSize: "product-size",
  productGatedNotice: "product-gated-notice",

  // Cart
  cartPage: "cart-page",
  cartEmpty: "cart-empty",
  cartItem: "cart-item",
  cartCheckout: "cart-checkout-btn",
  cartSubtotal: "cart-subtotal",
  cartMoqWarning: "cart-moq-warning",

  // Checkout
  checkoutPage: "checkout-page",
  checkoutAddress: "checkout-address",
  checkoutNotes: "checkout-notes",
  checkoutSubmit: "checkout-submit",
  checkoutSuccess: "checkout-success",
  checkoutError: "checkout-error",
  checkoutSplitNotice: "checkout-split-notice",
  checkoutSuccessOrder: "checkout-success-order",
  checkoutSuccessViewOrders: "checkout-success-view-orders",
  checkoutSuccessGstNumber: "checkout-success-gst-number",
  checkoutSuccessEtransfer: "checkout-success-etransfer",
  checkoutSuccessFooter: "checkout-success-footer",

  // My Orders
  myOrdersPage: "my-orders-page",
  myOrdersEmpty: "my-orders-empty",
  orderCard: "order-card",

  // Admin
  adminTabProducts: "admin-tab-products",
  adminTabUsers: "admin-tab-users",
  adminTabOrders: "admin-tab-orders",
  adminTabSettings: "admin-tab-settings",
  adminTabTerms: "admin-tab-terms",
  adminUserApproveToggle: "admin-user-approve-toggle",
  adminOrderStatus: "admin-order-status",

  // Terms (Admin)
  termsEditor: "terms-editor",
  termsTextarea: "terms-textarea",
  termsPreview: "terms-preview",
  termsForceResign: "terms-force-resign",
  termsSaveBtn: "terms-save-btn",
  termsToolbarBold: "terms-toolbar-bold",
  termsToolbarItalic: "terms-toolbar-italic",
  termsToolbarH1: "terms-toolbar-h1",
  termsToolbarH2: "terms-toolbar-h2",
  termsToolbarList: "terms-toolbar-list",
  termsToolbarLink: "terms-toolbar-link",

  // Terms (Checkout)
  checkoutTermsBanner: "checkout-terms-banner",
  checkoutTermsCheckbox: "checkout-terms-checkbox",
  checkoutTermsText: "checkout-terms-text",

  // Footer
  footerShopRetail: "footer-shop-retail",
};

export default testIds;
